import { serverRouteConfig } from "@server/serverRouteConfig"
import { createFileRoute } from "@tanstack/react-router"

export const Route = createFileRoute("/api/dashboard/auth/session")(
  serverRouteConfig({
    server: {
      handlers: {
        GET: async ({ request }) => {
          const { readDashboardSessionResponse } = await import(
            "@api/features/dashboard-auth/dashboardAuthApi"
          )
          return readDashboardSessionResponse(request)
        },
      },
    },
  })
)
